import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { memo } from 'react';
import { Simplify } from '../../../../../prismicio-types';

import { BulletIcons } from '@/assets';
import { Button } from '@/components';
import styles from './productsInformationTextItem.module.scss';

interface ProductsInformationTextItemProps {
  isActive: boolean;
  item: Simplify<Content.ProductsInformationSliceDefaultPrimaryProductsItem>;
  isVisible: boolean;
}

const components: JSXMapSerializer = {
  heading3: ({ children }) => <h3 className={styles.title}>{children}</h3>,
  list: ({ children }) => <ul className={styles.list}>{children}</ul>,
  listItem: ({ children }) => (
    <li className={`${styles.advantages_item}`}>
      <BulletIcons icon="check" />
      {children}
    </li>
  ),
};

const ProductsInformationTextItemComponent = ({
  isActive,
  item,
  isVisible,
}: ProductsInformationTextItemProps) => {
  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <li
      className={`${styles.list_item} ${isActive ? styles.visible : styles.hidden}`}
    >
      <div className={`${styles.title_wrapper} ${isVisibleStyles}`}>
        <PrismicRichText field={item.heading} components={components} />
      </div>
      <p className={`${styles.subtitle} ${isVisibleStyles}`}>{item.subtitle}</p>
      <div className={`${styles.list_wrapper} ${isVisibleStyles}`}>
        <PrismicRichText field={item.advantages} components={components} />
      </div>
      <div className={`${styles.button_wrapper} ${isVisibleStyles}`}>
        <Button
          text={item.button_text}
          link={item.button_link}
          variation="white"
        />
      </div>
    </li>
  );
};

export const ProductsInformationTextItem = memo(
  ProductsInformationTextItemComponent
);
